
import React, { useEffect } from 'react'; 
 
import TextField from '@mui/material/TextField';
import SearchRounded from '@mui/icons-material/SearchRounded';
import InputAdornment from '@mui/material/InputAdornment';
import {
    useSearchParams,
    useNavigate
  } from "react-router-dom";

import "../css/browse-table.css";
import ElementDialog from "./element-dialog"; 


export default function SearchBox(props:any) {

    let [searchParams, setSearchParams] = useSearchParams();
    let navigate = useNavigate();
    const [openExpDialog, setOpenExpDialog] = React.useState(false);
    const [expDialogData, setExpDialogData] = React.useState<any>(null);


    /**
 * 
 * @param query 
 * @returns 
 */
function getCleanQueryInput(query:string):string {
    let cleanV = query.replace(":", " ");
    cleanV = cleanV.replaceAll("-", " ");
    cleanV = cleanV.replaceAll(",", "");
    cleanV = cleanV.replaceAll("'", ""); 
    cleanV = cleanV.replace(/\t/g, ' ');
    cleanV = cleanV.toString().trim().replace(/(\r\n|\n|\r)/g,"");    
    cleanV = cleanV.replace(/\s\s+/g, ' ');
  
    return cleanV;
  }
  
  /**
   * 
   * @param query 
   * @returns 
   */
  function getCoordQuery(query:string) {
    let cleanV = getCleanQueryInput(query);
    let filterValueTokens = cleanV.split(" ");
  
    if(filterValueTokens.length===3 && 
        filterValueTokens[0] &&
        filterValueTokens[1] &&
        filterValueTokens[2])
    {      
        const chrRegex = new RegExp('(chr(([1-9]|1[0-9]|2[0-2]){1}|x{1}|y{1}))$'); 
        console.log("test:", filterValueTokens[0].toLowerCase() , chrRegex.test(filterValueTokens[0].toLowerCase()));
        if(chrRegex.test(filterValueTokens[0].toLowerCase())===true)
        {
            console.log("G coord chr:", filterValueTokens[0]);
            return "coord=" + filterValueTokens[0] + "-" + filterValueTokens[1] + "-" + filterValueTokens[2];
        }
        else
        {
            return null;
        }
    }
    else
    {
        return null;
    }
  
  }
  
  
  function parseSimpleQuery(query:string|null):any {
    if(!query)
        return;
    console.log(query);
    let url = "";
    const vistaIDRegex = new RegExp('(hs|mm|xx|x)[0-9]+(.[0-9]+)?'); 
    if(vistaIDRegex.test(query)===true)
    {  
        let _vistaId:any = query;
        let _alleleId:any = 0;
  
        let tokens = query.split(".");
        if(tokens.length === 2)
        {
            _vistaId = tokens[0];
            _alleleId = tokens[1];
        }
        if(_alleleId) {
        //direct to element page
        // url = `/element?vistaId=${_vistaId}&alleleId=${_alleleId}`; 
        // return {type:"url", value: url};
        return {type:"props", value:"vistaId="+_vistaId+"&alleleId="+_alleleId};
        
        }
        else {
          return {type:"props", value:"vistaId="+_vistaId};
        }
    }   
    
    let coordQuery = getCoordQuery(query); 
    console.log("------coordQuery",coordQuery);
    if(coordQuery)
    {
        return {type: "props", value: coordQuery};
    }
      
    let geneNameQuery = getCleanQueryInput(query);  
    if(geneNameQuery)
    {
        console.log("Gene name query:", geneNameQuery);
        return {type: "props", value: "gene="+geneNameQuery};
    }
  }
  
  
  function parseAdvancedQuery(searchParams:URLSearchParams) {
  
    var query: string = "";
    
    var filters: string[];
    filters = [];
    searchParams.forEach((value, key) => {
      //if(key === "vistaId" || key === "alleleId" || key === "gene" || key === "stage" || key === "expressions" || key === "tissue" || key === "backbone")
        filters.push(key+"="+value);
    })
    query = filters.join("&")
    console.log(query)
    return({type: "props", value: query})
  
  }





    const SimpleQueryHandler = (props:any, query:string|null) => {
        if(query === null)
          props.loadData(null);
        let res = parseSimpleQuery(query);
        if(res.type === "url") {
            navigate(res.value)
            return;
        }
        else {
            props.loadData(res.value);
            return;
        }
    }; 

    const AdvancedQueryHandler = (props: any, searchParams:any|null) => {
        let res = parseAdvancedQuery(searchParams);
        props.loadData(res.value);
        return;
    };

    useEffect(() => { 
        if(searchParams === null)
          SimpleQueryHandler(props, null);
        let adv = searchParams.get("advanced");
        if(adv) {
            AdvancedQueryHandler(props, searchParams);
        }
        else {
        let sp = searchParams.get("filter"); 
        if(sp)
        {
            SimpleQueryHandler(props, sp);
        }
        
    }
    }, [])


    const handleKeyPress = (event: any) => {
     

        if(event.key === 'Enter')
        {
            let sp = searchParams.get("filter");
            console.log(sp);
            SimpleQueryHandler(props, sp);
          
          //props.loadData(searchParams.get("filter"));
          //navigate(`/browse?q=${searchValue}`);
          //event.preventDefault();
        }
    
    };


    const handleCloseExpDialog = (value: string) => {
        setOpenExpDialog(false);
    };


    return (
        <div style={{textAlign:"left", width:"60%", margin:"0 auto"}}>
            <TextField 
            fullWidth
            label="Quick Search"  
            size="medium"
            value={searchParams.get("filter") || searchParams.get("advanced")||""}
            onChange={(event) => {
                let filter = event.target.value;
                if (filter) {
                  setSearchParams({ filter }); 
                } else {
                  setSearchParams({}); 
                }
              }}
            onKeyPress={handleKeyPress}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchRounded />
                </InputAdornment>
              ),
            }}
            >
            </TextField>
        
            <ElementDialog open={openExpDialog} 
                            onClose={handleCloseExpDialog}
                            data={expDialogData}></ElementDialog>
        <span style={{fontSize:"12px"}}>Enter a <b>Vista ID</b> (e.g. hs72.0 or hs2766), a <b>flanking gene name</b> (e.g. IRF8) or <b>element coordinates</b> (e.g. chr16:86396481-86397120).</span>
        </div>
    );

}